import { alpha, Container, LinearProgress } from "@mui/material";
import { gridClasses } from "@mui/x-data-grid";

const useStyles = (theme) => ({
  dataGrid: {
    mt: "15px",
    height: "100%",
    minHeight: "300px",
    width: "100%",
    fontSize: "0.875rem",

    backgroundColor: theme.palette.background.paper,
    border: "none", // "1px solid " + theme.palette.color.appBarBorder,

    [`& .${gridClasses.row}.even`]: {
      backgroundColor: alpha(theme.palette.background.default, 0.1),
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: alpha(theme.palette.background.default, 0.8),
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
      position: "relative",

      "&::after": {
        content: '""',
        position: "absolute",
        right: 0,
        top: "50%", // Posiciona no meio
        height: "35%", // Define 35% da altura da célula
        width: "1px", // Largura da borda
        backgroundColor: theme.palette.color.appBarBorder, // Cor da borda
        transform: "translateY(-50%)", // Ajusta a posição verticalmente
      },
    },
    "& .MuiDataGrid-cell": {
      border: "none",
      borderTop: "none",
      borderBottom: "1px solid " + theme.palette.color.appBarBorder,
      color: theme.palette.text.shadow,
    },

    "& .MuiDataGrid-columnHeader": {
      // backgroundColor:
      //   theme.palette.mode == "dark" ? "#202226" : "rgb(223, 221, 217)",

      // color: theme.palette.primary.main,
      borderTop: "1px solid " + theme.palette.color.appBarBorder,

      color: theme.palette.text.primary,
    },
  },
  chipAdd: {
    color: theme.palette.success.main,
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    height: "25px",
  },
  chipDel: {
    color: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.main, 0.1),
    height: "25px",
  },
  chipProtocol: {
    color: theme.palette.text.primary,
    backgroundColor: alpha(theme.palette.text.primary, 0.1),
    height: "25px",
  },
  bar: {
    height: "20px",
    width: "3px",
    mr: 1,
    backgroundColor: theme.palette.easyLog.primary,
    borderRadius: "1px",
  },
  containerColumnChip: {
    display: "flex",
    flexWrap: "wrap",
    height: "100%",
    fontWeight: "bold",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  searchInput: {
    width: { xs: "100%", md: "400px" },
  },
  titlePaper: {
    fontSize: "1rem",
    fontWeight: "bold",
    width: "100%",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    color: theme.palette.text.shadow,
    height: "30px",
  },
  boxType: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
    padding: "10px",
    backgroundColor: theme.palette.easyLog.primary,
    position: "absolute",
    top: "0px",
    right: "20px",
    fontSize: "0.8rem",
    color: "white",
    fontWeight: 500,
    borderBottomLeftRadius: "3px",
    borderBottomRightRadius: "3px",
  },
  linearProgress: {
    height: "15px",
    width: "100%",
    borderRadius: "2px",
    backgroundColor: alpha(theme.palette.easyLog.primary, 0.2),

    "& .MuiLinearProgress-bar": {
      backgroundColor: theme.palette.easyLog.primary,
      //borderRight: "1px solid" + theme.palette.easyLog.secondary,
      boxShadow: "0px 0px 10px 0px " + theme.palette.easyLog.primary,
    },
  },
  textProgress: {
    fontWeight: 500,
    width: "60px",
    textAlign: "center",
    fontSize: "0.875rem",
    color: theme.palette.text.primary,
  },
  paper: {
    height: "68vh",

    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    position: "relative",
    //boxShadow: "0px 0px 5px  #0000000a",
  },
  paperTitlePage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  },
  container: {
    display: "flex",
    width: "100%",
    flexDirection: { xs: "column", xl: "row" },
    gap: "10px",
  },
  buttomDataGrid: {
    color: theme.palette.text.shadow,
  },
  containerButtomDataGrid: {
    position: "absolute",
    top: "5px",
    right: "100px",
    display: "flex",
    flexDirection: "row",
  },
  paperModal: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "450px",
    minWidth: "265px",
    width: "85%",
    height: "auto",
    padding: "13px 16px 16px 16px",
    borderRadius: "5px",
    position: "relative",
    overflow: "hidden",
    minHeight: "345px",
    height: "auto",
  },
  lineStack: {
    width: "100%",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    gap: "38px",

    //flexWrap: "wrap",
  },
  cardStack: {
    flexDirection: "column",
    width: "50%",
    alignItems: "start",
    justifyContent: "start",
    wordBreak: "break-all",
    overflowWrap: "break-word",
    minHeight: "41px",
  },
  cardUserSubTitle: {
    fontSize: "13px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "3px",
  },
  cardUserSubTitleIcon: {
    fontSize: "18px",
    color: theme.palette.easyLog.tertiary,
  },
  cardText: {
    fontSize: "14px",
    overflow: "hidden",
    wordBreak: "break-all",
    overflowWrap: "break-word",
    marginLeft: "20px",
  },
  portaBNGTexto: {
    marginLeft: "20px",
    fontSize: "14px",
    wordBreak: "break-all",
    minHeight: "41px",
  },
  stackErro: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
    flex: 1,
    gap: "10px",
  },
  stackErroIcon: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    gap: "10px",
  },
});
export default useStyles;
